import { useChatSocket } from '../contexts/ChatSocketContext';

export const useUnreadMessagesCount = (currentUserId?: string | null): number => {
  const { totalUnreadCount } = useChatSocket();
  return currentUserId ? totalUnreadCount : 0;
};